import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';

export const StChipScrollContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: '8px',
  marginBottom: '24px',
  justifyContent: 'flex-start',
  overflowX: 'auto',
  WebkitOverflowScrolling: 'touch',
  scrollbarWidth: 'none',
  flexWrap: 'wrap',
  margin: '22px 37px',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
  [theme.breakpoints.up('md')]: {
    justifyContent: 'center',
    overflowX: 'visible',
  },
  [theme.breakpoints.up('lg')]: {
    gap: '12px',
    fontWeight: 500,
  },
}));

interface StChipButtonProps {
  active?: boolean;
}

export const StChipButton = styled('button', {
  shouldForwardProp: (prop) => prop !== 'active',
})<StChipButtonProps>(({ theme, active }) => ({
  flexShrink: 0,
  borderRadius: '9999px',
  border: `1px solid ${
    active ? theme.palette.primary.main : theme.palette.neutral4?.main || '#D9D9D9'
  }`,
  backgroundColor: active ? theme.palette.primary.main : theme.palette.white.main,
  color: active ? theme.palette.white.main : theme.palette.neutral7?.main || '#64748B',
  padding: '8px 12px',
  fontSize: '14px',
  fontWeight: 500,
  lineHeight: 1.4,
  cursor: 'pointer',
  textTransform: 'none',
  fontFamily: `${theme.palette.primaryFontFamilyType}, sans-serif`,
  whiteSpace: 'nowrap',
  outline: 'none',
  [theme.breakpoints.up(500)]: {
    padding: '8px 16px',
    fontSize: '14px',
    fontWeight: 600,
  },
  '&:hover': {
    backgroundColor: active ? theme.palette.primary.main : theme.palette.white.main,
    color: active ? theme.palette.white.main : theme.palette.primary.main,
    borderColor: theme.palette.primary.main,
  },
}));
